import { View, Text, FlatList } from 'react-native'
import React, { FunctionComponent, useMemo } from 'react'

import { CollectiviteProps } from './Collectivite.types'
import styles from './Collectivite.styles'
import { useSessionStore } from '../../lib/Store/sessionStore.component'
import CollectiviteItem from './CollectiviteItem'

export const Collectivite: FunctionComponent<CollectiviteProps> = ({ navigation, withoutTitle = false }) => {
    const { accessibleDatabases } = useSessionStore();

    const renderEmptyList = useMemo(() => (
      <View style={styles.emptyContainer}>
        <Text style={styles.emptyText}>
          Aucune collectivité disponible{'\n'}
          Veuillez vous reconnecter
        </Text>
      </View>
    ), [])

    return (
      <View style={styles.container}>
        {!withoutTitle && (<Text style={styles.titre}>Sélectionnez une collectivité</Text>)}
        <FlatList
          data={accessibleDatabases}
          keyExtractor={(database)=>`${database.tenant?.identifiant}_${database.component?.identifiant}`}
          renderItem={({item, index}) => (
            <CollectiviteItem
              index={index}
              database={item}
              navigation={navigation}
            />
          )}
          ListEmptyComponent={renderEmptyList}
          showsVerticalScrollIndicator={false}
          testID='SC_DATABASES'
        />
      </View>
    );
}